export default __webpack_public_path__ + "static/media/plus-button.524a3473.svg";